import { useState } from "react";
import orionAPI from "../config/orionAPI";

const useCryptoSubscription = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const subscribeCrypto = async (subscriptionPlanId, payCurrency) => {
    setLoading(true);
    setError(null);

    try {
      const response = await orionAPI.post("/api/users/me/subscribe/crypto", {
        subscription_plan_id: subscriptionPlanId,
        pay_currency: payCurrency.toLowerCase()
      });

      if (response.data && response.data.data && response.data.data.invoice_url) {
        const invoiceUrl = response.data.data.invoice_url;
        
        setTimeout(() => {
          window.open(invoiceUrl, '_blank', 'noopener,noreferrer');
        }, 1000);
        
        return {
          success: true,
          invoice_url: invoiceUrl
        };
      } else {
        throw new Error("URL do pagamento não encontrada na resposta");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.message || 
                          "Não foi possível processar o pagamento";
      
      setError(errorMessage);
      
      return {
        success: false,
        error: errorMessage
      };
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => {
    setError(null);
  };

  return {
    subscribeCrypto,
    loading,
    error,
    clearError
  };
};

export default useCryptoSubscription;